import type { ComboInstrument } from "#/store/combo/comboInstruments";
import { type GetOrderbookResponse } from "#/types/api";
import {
  createOptionInstrumentName,
  createPerpInstrumentName,
  isOptionInstrument,
} from "#/utils/instrument.utils";
import { isBuy } from "#/utils/marketActionConverter";

const getComboInstrumentName = (instrument: ComboInstrument) => {
  const isOption = isOptionInstrument(instrument.type);
  if (isOption && instrument.strike === 0) return "";

  return isOption
    ? createOptionInstrumentName(instrument)
    : createPerpInstrumentName(instrument.underlying);
};

export const getComboInstrumentNames = (
  comboInstruments: ComboInstrument[],
) => {
  const instrumentNames = comboInstruments.map((instrument) =>
    getComboInstrumentName(instrument),
  );

  return instrumentNames.includes("") ? [] : instrumentNames;
};

export const updateComboInstrumentsByLegPrice = (
  comboInstruments: ComboInstrument[],
  orderbook: GetOrderbookResponse[] | undefined,
) => {
  if (!orderbook?.length) return comboInstruments;

  return comboInstruments.map((item) => {
    const instrumentName = getComboInstrumentName(item);

    const orderbookEntry = orderbook.find(
      (entry) => entry.instrument_name === instrumentName,
    );

    if (!orderbookEntry) return item;

    const legPrice = isBuy(item.side)
      ? (orderbookEntry.best_ask_price ?? NaN)
      : (orderbookEntry.best_bid_price ?? NaN);

    return { ...item, legPrice };
  });
};
